<template>
  <section class="custom-message-wrapper">
    <div v-if="isBatch" class="custom-recipients">
      <span># recipients: {{ numRecipients }}</span>
    </div>
    <div v-show="numRecipients > 0 || !isBatch">
      <z-tabs
        v-model="currentTab"
        :tabs="tabs"
        :badges="badges"
        @change="showTab"
      />
      <div class="row mb-2">
        <div class="col-md-12">
          <div class="input-group mt-2">
            <span class="input-group-text">send as:</span>
            <div class="input-group-text custom-message-check">
              <input
                ref="chkEmail"
                class="form-check-input mt-0"
                type="checkbox"
                v-model="isEmail"
              />
            </div>
            <span class="input-group-text">email</span>
            <div class="input-group-text custom-message-check">
              <input
                ref="chkNotification"
                class="form-check-input mt-0"
                type="checkbox"
                v-model="isNotification"
              />
            </div>
            <span class="input-group-text">coaching wall message</span>
            <select
              class="form-select"
              v-model="msgType"
              @change="msgTypeChanged"
            >
              <option
                v-for="msgType of msgTypes"
                :key="msgType.id"
                :value="msgType.value"
                :disabled="msgType.id === 0"
              >
                {{ msgType.name }}
              </option>
            </select>
            <select
              v-if="msgType !== null && msgType !== 0"
              class="form-select"
              v-model="activityWeek"
              @change="activityWeekChanged"
            >
              <option
                v-for="week of activityWeeks"
                :key="week.id"
                :value="week.value"
              >
                {{ week.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-12">
          <z-message
            v-model="notice"
            :timeout="3000"
            class="alert alert-warning"
          />
        </div>
      </div>
      <div v-show="currentTab === 'Attachments'" class="row">
        <div class="col-md-12">
          <file-upload
            ref="fileUploader"
            title=""
            subtitle=""
            instructions="Drag your files (in pdf, doc, png, or jpg format) here to begin or click to browse"
            :endpoint="endpoint"
            :id="orgId"
            :path="path"
            :folder="folder"
            :accept="accept"
            :key="uploadKey"
            :isShowSave="false"
            :isDontSave="true"
            :isShowList="true"
            :existingFiles="existingFiles"
            @filesAdded="filesAttached"
            @show="showFile"
          />
        </div>
      </div>
      <div v-show="currentTab === 'Message'" class="row">
        <div class="col-md-12">
          <div class="row mb-2">
            <div v-if="isSingle && !isBatch" class="col-md-12">
              <span class="me-3">To:</span>
              <img :src="avatar" class="custom-avatar" />
              <span class="ms-2">{{ sendTo }}</span>
              <button
                class="btn btn-primary btn-sm custom-reply"
                @click="setNew"
              >
                <span>New</span>
              </button>
            </div>
            <div v-else-if="!isBatch" class="col-md-12">
              <auto-suggest
                v-model="selectedMembers"
                placeholder="add a client (type to search)"
                :minChars="2"
                :delay="750"
                :searchable="true"
                :options="searchHandler"
                :object="true"
                :filterResults="false"
                :resolveOnLoad="false"
                mode="tags"
                @clear="validateMessage(1)"
                @select="validateMessage(2)"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-md-8">
              <z-input
                v-show="msgEmail"
                v-model="subject"
                name="subject"
                placeholder="subject"
                :addStyle="subjectStyle"
                @keyup="validateMessage(3)"
              />
            </div>
            <div class="col-md-4 mb-2">
              <select class="form-select" v-model="tag" @change="tagChanged">
                <option
                  v-for="tag of tags"
                  :key="tag.id"
                  :value="tag.value"
                  :disabled="tag.disabled"
                >
                  {{ tag.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="row">
            <div v-if="isBatch" class="col-12 custom-batch-messages">
              <batch-messages ref="batchMessages" @edited="changed" />
            </div>
            <div v-else class="col-md-12 custom-editor">
              <editor
                ref="zEditor"
                :modules="modules"
                @message="showMessage"
                @textChange="validateMessage(4)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="numRecipients <= 0 && isBatch">
      <p>Please select (check) recipients from the coach wall grid.</p>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import * as axios from 'axios'
import AutoSuggest from '@vueform/multiselect'
import ZInput from '@/Components/ZElements/Input'
import ZMessage from '@/Components/ZElements/Message'
import Editor from '@/Components/ZElements/Editor.vue'
import FileUpload from '@/Components/ZElements/Upload'
import ZTabs from '@/Components/ZElements/Tabs'
import BatchMessages from './batch-messages.vue'
export default {
  name: 'email-message',
  components: {
    ZInput,
    ZMessage,
    Editor,
    FileUpload,
    AutoSuggest,
    ZTabs,
    BatchMessages,
  },
  props: {
    view: {
      type: Object,
      default: null,
    },
    msgId: {
      type: [String, Number],
      default: null,
    },
    isBatch: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      notice: '',
      msgEmail: false,
      msgNotification: false,
      subject: '',
      body: '',
      msgTypes: [
        {
          id: 0,
          name: 'select progress (optional)',
          value: null,
        },
        {
          id: 2,
          name: '',
          value: null,
        },
        {
          id: 1,
          name: 'Activity Progress',
          value: 9990,
        },
        {
          id: 4,
          name: 'Body Composition Progress',
          value: 9992,
        },
        {
          id: 5,
          name: 'Nutrition Progress',
          value: 9993,
        },
        // {
        //   id: 2,
        //   name: 'User Trend',
        //   value: 9991,
        // },
      ],
      msgType: null,
      tag: 'label',
      endpoint: 'api/v2/messages/attachments',
      uploadKey: 0,
      folder: '',
      path: '',
      chosenMembers: null,
      accept:
        'image/*,text/*,application/pdf,application/msword,application/vnd.ms-excel,application/vnd.ms-powerpoint,application/gzip,application/zip',
      subjectStyle: 'border: 1px solid red;',
      currentTab: 'Message',
      badges: [
        {
          name: 'Attachments',
          count: 0,
        },
      ],
      existingFiles: [],
      activityWeek: 0,
      activityWeeks: [
        {
          id: 0,
          name: 'for This Week',
          value: 0,
        },
        {
          id: 1,
          name: 'for Last Week',
          value: 1,
        },
      ],
      currentStatus: null,
      modules: {
        name: 'imageUploader',
        module: ImageUploader,
        options: {
          upload: this.uploader,
          // (file) => {
          //   return new Promise((resolve, reject) => {
          //     const formData = new FormData()
          //     formData.append('files[]', file)
          //     let api = `${location.origin}/${this.endpoint}`
          //     if (this.orgId !== null) {
          //       api += `/${this.orgId}`
          //     }
          //     if (this.folder !== null) {
          //       api += `/messages`
          //     }
          //     axios
          //       .post(api, formData, {
          //         headers: {
          //           'Content-Type': `multipart/form-data;boundary=${Math.random().toString()}`,
          //         },
          //       })
          //       .then((res) => {
          //         console.log('Files Uploaded', res)
          //         resolve(res.data.data)
          //       })
          //       .catch((err) => {
          //         reject('upload failed')
          //         console.error('Error:', err)
          //       })
          //   })
          // },
        },
      },
    }
  },
  mounted() {
    this.init()
    if (this.workingText) {
      this.presetWallMessage(this.workingText)
    }
  },
  watch: {
    msgId() {
      this.setWallMessage()
    },
  },
  emits: ['valid', 'show', 'edited'],
  computed: {
    ...mapGetters('organizations', ['examineOrganization']),
    ...mapGetters('messages', ['recipients', 'message']),
    ...mapGetters('usercardio', ['lists', 'memberids', 'summary']),
    ...mapGetters('coaching', ['wallmessage', 'mergeTags', 'workingText']),
    ...mapGetters('configuration', ['selectedBiTemplate']),
    tabs() {
      let _tabs = ['Message']
      if (this.msgEmail || this.isAttachments) {
        _tabs.push('Attachments')
      }
      return _tabs
    },
    tags() {
      let _tags = []
      if (this.mergeTags) {
        _tags = this.mergeTags
      }
      return _tags
    },
    numRecipients() {
      let _num = null
      if (this.recipients) {
        _num = this.recipients.length
      }
      return _num
    },
    messageType: {
      get() {
        let _data = null
        if (this.msgEmail && this.msgNotification) {
          _data = 'both'
        } else if (this.msgEmail) {
          _data = 'email'
        } else if (this.msgNotification) {
          _data = 'notification'
        }
        return _data
      },
    },
    isEmail: {
      get() {
        let _data = false
        if (this.view) {
          if (this.view.type === 'email' || this.view.type === 'both') {
            console.log('Message Type (Email)', this.view.type)
            _data = true
          }
        }
        return _data
      },
      set(value) {
        setTimeout(() => {
          this.setView('email', value)
          this.validateMessage(5)
          this.validateTabs()
        }, 100)
      },
    },
    isNotification: {
      get() {
        let _data = false
        if (this.view) {
          if (this.view.type === 'notification' || this.view.type === 'both') {
            console.log('Message Type (Notification)', this.view.type)
            _data = true
          }
        }
        return _data
      },
      set(value) {
        setTimeout(() => {
          this.setView('notification', value)
          this.validateMessage(6)
          this.validateTabs()
        }, 100)
      },
    },
    selectedMembers: {
      get() {
        let _data = []
        this.memberids.forEach((element) => {
          let name = `${element.FirstName} ${element.LastName}`
          _data.push({
            id: element.user_id,
            value: name,
            label: name,
          })
        })
        return _data
      },
      set(value) {
        this.setRecipients({
          source: 1,
          recipients: value,
        })
      },
    },
    orgId() {
      let _data = null
      if (
        this.examineOrganization !== undefined &&
        this.examineOrganization !== null
      ) {
        _data = this.examineOrganization.id
      }
      return _data
    },
    isSingle() {
      let _data = false
      if (this.view) {
        if (this.view.memberids === null) {
          _data = true
          this.setRecipients({
            source: 1,
            recipients: [
              {
                id: this.view.id,
                value: this.sendTo,
                label: this.sendTo,
              },
            ],
          })
        }
      }
      return _data
    },
    avatar() {
      let _data = null
      if (this.view) {
        _data = this.view.avatar
      }
      return _data
    },
    sendTo() {
      let _data = null
      if (this.view) {
        if (this.view.nickName !== '') {
          _data = `${this.view.lastName}, ${this.view.firstName} (${this.view.nickName})`
        } else {
          _data = `${this.view.lastName}, ${this.view.firstName}`
        }
      }
      return _data
    },
    isEdit() {
      let _data = false
      if (this.msgId) {
        if (this.msgId !== null) {
          _data = true
        }
      }
      return _data
    },
    isAttachments() {
      let _is = false
      if (this.wallmessage) {
        if (this.wallmessage.attachments) {
          if (this.wallmessage.attachments !== '') {
            let attachList = JSON.parse(this.wallmessage.attachments)
            if (attachList.length > 0) {
              _is = true
            }
          }
        }
      }
      return _is
    },
  },
  methods: {
    ...mapActions('users', ['findUsers']),
    ...mapActions('messages', ['saveMessage', 'setMessage', 'setRecipients']),
    ...mapActions('coaching', [
      'saveWallMessage',
      'resetWallMessage',
      'setWorkingText',
    ]),
    init() {
      console.log('Email Message Init')
      this.tag = 'label'
      this.msgEmail = false
      this.msgNotification = true
      this.msgType = null
      this.activityWeek = 0
      this.notice = ''
      this.currentTab = 'Message'
      this.isSending = false
      this.badges = [
        {
          name: 'Attachments',
          count: 0,
        },
      ]
      this.existingFiles = []
      this.$refs.fileUploader.reset()
      this.$emit('edited', false)
      console.log('Summary (Init):', this.summary)
    },
    showTab(tab) {
      this.currentTab = tab
    },
    showMessage(msg) {
      this.notice = msg
    },
    messageBody() {
      let body = ''
      if (this.$refs.zEditor) {
        body = this.$refs.zEditor.getHTML()
        if (body === '' || body === '<p><br></p>') {
          body = ''
        }
      }
      return body
    },
    setView(type, value) {
      if (type === 'notification') {
        this.msgNotification = value
      } else if (type === 'email') {
        this.msgEmail = value
      }
      if (this.msgEmail && this.msgNotification) {
        this.view.type = 'both'
      } else if (this.msgEmail) {
        this.view.type = 'email'
      } else {
        this.view.type = 'notification'
      }
    },
    setNew() {
      this.init()
      this.msgEmail = false
      this.msgNotification = true
      this.$refs.chkEmail.checked = false
      this.$refs.chkNotification.checked = true
      this.subject = ''
      console.log('Set as New', {
        view: this.view,
        isEdit: this.isEdit,
        isNotification: this.isNotification,
      })
      let data = {
        id: this.view.id,
        orgId: this.examineOrganization.id,
      }
      this.setView('notification', true)
      this.setWorkingText(null)
      this.resetWallMessage(data)
      this.setWallMessage()
      this.$emit('setNew')
      this.$emit('edited', false)
    },
    presetWallMessage(text) {
      console.log('Presetting Wall Message', text)
      if (this.$refs.zEditor) {
        this.$refs.zEditor.setHTML(text)
      }
    },
    setWallMessage() {
      console.log('Resetting Wall Message (and attachments)', this.wallmessage)
      if (this.$refs.zEditor) {
        this.$refs.zEditor.setHTML(null)
        if (this.wallmessage) {
          if (this.wallmessage.text) {
            this.$refs.zEditor.setHTML(this.wallmessage.text)
            this.setAttachments()
          }
        }
      }
      let $this = this
      setTimeout(() => {
        $this.$emit('edited', false)
      }, 250)
    },
    setAttachments() {
      if (this.wallmessage) {
        if (this.wallmessage.attachments) {
          if (this.wallmessage.attachments !== '') {
            let attachList = JSON.parse(this.wallmessage.attachments)
            this.existingFiles = []
            attachList.forEach((element) => {
              if (element.Uri !== '') {
                let segments = element.Uri.split('/')
                let filename = segments[segments.length - 1]
                this.existingFiles.push({
                  name: filename,
                  url: element.Uri,
                })
              }
            })
            this.badges[0].count = this.existingFiles.length
          }
        }
      }
      this.$emit('edited', false)
    },
    async searchHandler(query) {
      let options = {
        term: query,
        orgId: this.examineOrganization.id,
      }
      return await this.findUsers(options)
    },
    tagChanged() {
      if (this.isBatch) {
        this.$refs.batchMessages.setTag(this.tag)
        this.tag = 'label'
      } else {
        this.$refs.zEditor.insertText(this.tag)
        this.tag = 'label'
        this.validateMessage(7)
      }
    },
    changed() {
      // this.$emit('edited', true)
      this.validateMessage(0)
    },
    validateMessage(id) {
      this.notice = ''
      let valid = true
      let whatsNot = ''
      console.log('Validate Message Occurred', {
        id: id,
        view: this.view,
        isEdit: this.isEdit,
      })
      if (!this.isEdit) {
        this.$emit('edited', true)
        if (this.subject.trim() === '' && this.msgEmail) {
          valid = false
          whatsNot = 'subject'
        }
        if (valid && this.messageType === null) {
          valid = false
          whatsNot = 'send as'
        }
        if (this.isBatch) {
          console.log('Validating Batch Messages', this.selectedBiTemplate)
          if (valid) {
            if (this.selectedBiTemplate === null) {
              valid = false
              whatsNot = 'template'
            } else {
              for (let i = 0; i < this.selectedBiTemplate.ranges.length; i++) {
                if (valid) {
                  if (this.selectedBiTemplate.ranges[i].message === null) {
                    valid = false
                    whatsNot = 'rangemessage'
                  } else if (
                    this.selectedBiTemplate.ranges[i].message.trim() === ''
                  ) {
                    valid = false
                    whatsNot = 'rangemessage'
                  }
                }
              }
            }
          }
        } else {
          let body = this.messageBody()
          if (valid && body.trim() === '') {
            valid = false
            whatsNot = 'body'
          }
          if (id === 4) {
            this.setWorkingText(body)
          }
          if (valid && this.recipients.length === 0) {
            valid = false
            whatsNot = 'recipients'
          }
        }
        let data = {
          isValid: valid,
          whatsNot: whatsNot,
          type: this.messageType,
        }
        console.log('valid?', data)
        this.$emit('valid', data)
      }
    },
    validateTabs() {
      if (!this.msgEmail && this.currentTab === 'Attachments') {
        this.currentTab = 'Message'
      }
    },
    msgTypeChanged() {
      console.log('Message Type Changed', this.msgType)
    },
    activityWeekChanged() {
      console.log('Activity Week Changed', this.activityWeek)
    },
    attach() {
      // console.log('Attaching File')
    },
    filesAttached(numfiles) {
      this.badges[0].count = numfiles
    },
    showFile(file) {
      this.$emit('show', file)
    },
    async getMessageData() {
      let files = await this.$refs.fileUploader.save()
      console.log('Selected Recipients', {
        recipients: this.recipients,
        attachments: files,
      })
      let recipients = ''
      this.recipients.forEach((element) => {
        if (recipients !== '') {
          recipients += ';'
        }
        recipients += element.id
      })
      let attachments = ''
      if (files) {
        files.forEach((element) => {
          if (attachments !== '') {
            attachments += ';'
          }
          attachments += element.FileName
        })
      }
      let emailOn = this.messageType === 'email' || this.messageType === 'both'
      let notificationOn =
        this.messageType === 'notification' || this.messageType === 'both'
      let msgtype = null
      if (
        this.msgType !== undefined &&
        this.msgType !== null &&
        this.msgType !== 0
      ) {
        msgtype = this.msgType
      }
      let coachDate = moment.utc().format('YYYY-MM-DD HH:mm:ss')
      if (this.activityWeek) {
        if (this.activityWeek === 1) {
          coachDate = moment
            .utc()
            .subtract(1, 'week')
            .format('YYYY-MM-DD HH:mm:ss')
        }
      } else {
        if (this.summary) {
          coachDate = this.summary.week.value + ' 00:00:00'
        }
      }
      let data = {
        isInvite: null,
        Attachments: attachments,
        IsSystem: msgtype === null ? 0 : 1,
        SystemMessageId: msgtype,
        SentDate: moment.utc().format('YYYY-MM-DD HH:mm:ss'),
        IsSession: null,
        CoachingDate: coachDate,
        Session: 0,
        NumberWeeks: 1,
        RecipientIds: recipients,
        Subject: this.subject,
        cannedmessage_id: msgtype,
        Body: this.messageBody(),
        email: emailOn ? 'on' : null,
        push: notificationOn ? 'on' : null,
        orgId: this.examineOrganization.id,
        async: true,
      }
      return data
    },
    uploader(file) {
      return new Promise((resolve, reject) => {
        const formData = new FormData()
        formData.append('files[]', file)
        let api = `${location.origin}/${this.endpoint}`
        if (this.orgId !== null) {
          api += `/${this.orgId}`
        }
        // if (this.folder !== null) {
        //   api += `/messages`
        // }
        axios
          .post(api, formData, {
            headers: {
              'Content-Type': `multipart/form-data;boundary=${Math.random().toString()}`,
            },
          })
          .then((res) => {
            console.log('Files Uploaded', res)
            // let link = null
            // if (res) {
            //   if (res.data) {
            //     if (res.data.data) {
            //       link = `<a href="${res.data.data[0].Url}" target_`
            //     }
            //   }
            // }
            resolve(res.data.data[0].Url)
          })
          .catch((err) => {
            reject('upload failed')
            console.error('Error:', err)
          })
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-message-wrapper {
  position: relative;
  height: 530px;
  padding-top: 10px;
}
.custom-message-check {
  background-color: rgb(255, 255, 255);
}
.custom-buttons {
  text-align: right;
  margin-top: 5px;
}
.custom-editor {
  height: 270px;
}
.custom-id {
  text-align: right;
  span {
    font-size: 0.7em;
  }
}
.custom-save-buttons {
  display: inline;
}
.custom-switch {
  display: inline;
  padding-left: 0;
  label {
    float: left;
    top: 5px;
    left: 5px;
    position: relative;
    font-size: 0.9em;
  }
  .form-check-input[type='checkbox'] {
    height: 25px;
    width: 50px;
    margin-left: -1.2em;
  }
  .custom-badge {
    top: -5px;
    position: relative;
  }
}
.custom-red {
  border: 1px solid red;
}
.custom-avatar {
  border-radius: 50%;
  width: 40px;
  height: 40px;
}
.custom-reply {
  right: 5px;
  position: absolute;
}
.custom-view-notice {
  right: 5px;
  position: absolute;
  color: green;
  font-weight: 500;
  font-size: 0.9em;
}
.custom-subdue {
  color: rgb(143, 143, 143);
}
.custom-batch-messages {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 350px;
}
.custom-recipients {
  position: absolute;
  right: 15px;
  top: 0;
}
</style>
